import { toNameConfigMapping } from '../../../configFields';
import { AuthStep } from './AuthStep';
import { MediaFileAudio } from './MediaFileAudio';
import { MediaFileImage } from './MediaFileImage';
import { MediaFileText } from './MediaFileText';
import { MediaFileVideo } from './MediaFileVideo';
import { MultiplePoll } from './MultiplePoll';
import { RatingDigitsPoll } from './RatingDigitsPoll';
import { RatingLikePoll } from './RatingLikePoll';
import { RatingSliderPoll } from './RatingSliderPoll';
import { RatingSmiliesPoll } from './RatingSmiliesPoll';
import { RatingStarsPoll } from './RatingStarsPoll';
import { SinglePoll } from './SinglePoll';
import { TextareaPoll } from './TextareaPoll';

export const Questions = {
  AuthStep,
  MediaFileImage,
  MediaFileAudio,
  MediaFileVideo,
  MediaFileText,
  SinglePoll,
  MultiplePoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  TextareaPoll,
};

export const questionsList = [
  AuthStep,
  MediaFileImage,
  MediaFileAudio,
  MediaFileVideo,
  MediaFileText,
  SinglePoll,
  MultiplePoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  TextareaPoll,
] as const;

export const questionsMapping = toNameConfigMapping(questionsList);
